import { useState } from 'react';
import type { ToolTraceEntry } from '../../api/types';

export default function ToolTrace({ trace }: { trace: ToolTraceEntry[] }) {
  const [open, setOpen] = useState(false);
  if (!trace?.length) return null;
  const totalMs = trace.reduce((s, t) => s + t.ms, 0);
  return (
    <div className="mt-2 border-t border-gray-100 pt-1">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="text-xs text-gray-400 hover:text-gray-600 font-mono"
      >
        {open ? '▾' : '▸'} {trace.length} tool call{trace.length === 1 ? '' : 's'} · {totalMs} ms
      </button>
      {open && (
        <ul className="mt-1 space-y-1">
          {trace.map((t, i) => (
            <li key={i} className="text-xs font-mono text-gray-500">
              <span className="text-pebbl-600">{t.tool}</span>
              <span className="text-gray-400">({JSON.stringify(t.args)})</span> · {t.ms} ms
              {t.resultSummary && (
                <div className="pl-4 text-gray-400 truncate" title={t.resultSummary}>
                  {t.resultSummary}
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
